@let vm = account();
@let cardSize = size();
@let iconSize = this.iconSize()[size()];
@let isActive = vm.card.status === cardStatusEnum.Active;
@let isBlocked = vm.card.status === cardStatusEnum.Blocked;
@let isClosed = vm.card.status === cardStatusEnum.Closed;
@let statusConfig = this.statusConfig();
@let failedStatusConfig = this.failedStatusConfig();
@let hasTextSpace =
  cardSize === "l" || cardSize === "xl" || cardSize === "mobile";

<div
  [class]="'wallet wallet-' + size()"
  [class.closed]="isClosed"
  [class.justify-center]="size() === 'xxs'"
>
  @if (isActive || isClosed) {
    @if (size() === "xxs") {
      <span class="currency d-flex align-center justify-center">
        <fu-icon
          [size]="iconSize"
          [iconName]="currentCard().currency?.symbol.toLowerCase() ?? ''"
        ></fu-icon>
      </span>
    } @else {
      <div class="wallet-header">
        <span class="wallet-pan d-flex align-center">
          {{ vm.card.pan | cardNumber }}
        </span>

        @if (isClosed && !menuShown()) {
          <span class="wallet-date">
            {{ vm.updatedAt | date: "MMM d, y" }}</span
          >
        }
      </div>

      <div class="wallet-description d-flex flex-col gap-1">
        <div class="wallet-balance" [class.wallet-balance-m]="size() === 'm'">
          <span class="currency"> {{ vm?.currency?.symbol }}</span>
          @let balance = vm?.balance | decimal;
          {{ !useBalanceMask() ? balance : (balance | maskBalance) }}
        </div>
        <div class="wallet-name">
          {{ size() === "m" ? (vm.card.pan | cardNumber) : vm.card.cardHolder }}
        </div>
        <span class="wallet-brand">
          <fu-icon [iconName]="'mastercard'" size="34"></fu-icon>
        </span>
      </div>

      @if (isClosed) {
        <div class="wallet-backdrop">
          <div class="backdrop-top"></div>
          <div class="backdrop-bottom"></div>
          <fu-icon class="backdrop-icon" iconName="closed-card" [size]="20" />
        </div>
      }
    }
  }
  @if (isBlocked) {
    @if (size() === "l") {
      <iw-button
        size="m"
        uiType="custom"
        class="wallet-blocked-btn"
        (clicked)="$event.stopPropagation(); action.emit(vm)"
        >{{ "cardView.bankCard.blocked.btn" | translate }}
      </iw-button>
    } @else {
      <div class="wallet-blocked-content">
        <h3 class="wallet-blocked-title">
          {{ "cardView.bankCard.blocked.title" | translate }}
        </h3>
        <p class="wallet-blocked-description">
          {{ "cardView.bankCard.blocked.description" | translate }}
        </p>
      </div>
    }

    <div class="wallet-backdrop">
      <div class="backdrop-top"></div>
      <div class="backdrop-bottom"></div>
      <fu-icon class="backdrop-icon" iconName="lock" size="30" />
    </div>
  }

  @if (failedStatusConfig) {
    @if (hasTextSpace && cardSize !== "l") {
      <div class="wallet-failed-content">
        <h3 class="wallet-failed-title">
          {{ `${failedStatusConfig.titleKey}` | translate }}
        </h3>
        <p class="wallet-failed-description">
          {{ "cardView.bankCard.failed.description" | translate }}
        </p>
      </div>
    }

    @if (hasTextSpace) {
      <iw-button
        size="m"
        uiType="custom"
        class="wallet-failed-btn"
        (clicked)="$event.stopPropagation(); action.emit(vm)"
      >
        {{ `${failedStatusConfig.btnKey}` | translate }}
      </iw-button>
    }

    <div class="wallet-backdrop" [class.center]="!hasTextSpace">
      <div class="backdrop-top"></div>
      <div class="backdrop-bottom"></div>
      <iw-tooltip
        [position]="'tc'"
        class="tooltip backdrop-icon"
        [maxWidth]="165"
        [title]="'cardView.bankCard.failed.description'"
        [customContent]="true"
      >
        <fu-icon
          iconName="information-circle"
          [size]="!hasTextSpace ? 16 : 30"
          [title]="'cardView.bankCard.failed.description' | translate"
        />
      </iw-tooltip>
    </div>
  }

  @if (statusConfig) {
    @if (hasTextSpace) {
      <div class="wallet-blocked-content">
        <h3 class="wallet-blocked-title">
          {{ statusConfig.titleKey | translate }}
        </h3>
        <p class="wallet-blocked-description">
          {{ statusConfig.descriptionKey | translate }}
        </p>
      </div>
    }

    <div class="wallet-backdrop" [class.center]="!hasTextSpace">
      <div class="backdrop-top"></div>
      <div class="backdrop-bottom"></div>
      <fu-icon
        iconName="loading"
        class="backdrop-icon"
        [size]="!hasTextSpace ? 16 : 30"
      />
    </div>
  }
</div>
